var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal-inventory","size":"xl","title":"Pilih Inventori","hide-footer":""}},[_c('Table',{attrs:{"purpose":"modal"},on:{"chosenItem":_vm.chosenItem}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }